// React
import React, { useEffect, useContext, useState } from "react";
// React
// CSS
import styles from "./QuizCreatorAnswerShower.module.css";
// CSS
// Modules
import { useLocation, useNavigate } from "react-router-dom";
import parse from "html-react-parser";
// Modules
// Images
import { quiz_result_header } from "../../../Images/images";
import { MdOutlineDone } from "react-icons/md";
// Images
// Contexts
import { UserQuestionsContext } from "../../../Contexts/UserQuestionsContext";
import { LessonDataContext } from "../../../Contexts/LessonDataContext";
// Contexts
// Icons
import { GrRadialSelected } from "react-icons/gr";
import { BiArrowBack } from "react-icons/bi";
// Icons

type QuizCreatorAnswerShowerProps = {
  setIsNeedFullScreenNeed: React.Dispatch<React.SetStateAction<boolean>>;
};

const QuizCreatorAnswerShower: React.FunctionComponent<
  QuizCreatorAnswerShowerProps
> = ({ setIsNeedFullScreenNeed }) => {
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  // Location Data
  const {
    state: { selectedAnswers, currMode },
  } = useLocation();
  console.log(selectedAnswers);
  // Location Data
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  // States
  const [mixedQuestionAndUserAnswer, setMixedQuestionAndUserAnswer] = useState<
    any[]
  >([]);
  // States
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  // Constants
  const navigate = useNavigate();
  const questions = useContext(UserQuestionsContext);
  const lessonData = useContext(LessonDataContext);
  // Constants
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  /******************************************************* */
  // LifeCycles
  useEffect(() => {
    if (
      selectedAnswers === null ||
      undefined ||
      questions === null ||
      undefined
    ) {
      navigate("/");
      return;
    }
    setMixedQuestionAndUserAnswer(() => {
      const data = [];
      for (let i = 0; i <= questions.length - 1; i++) {
        data[i] = {
          questions: questions[i],
          userAnswer: selectedAnswers[i],
        };
      }
      return data;
    });
  }, [navigate, selectedAnswers, questions]);

  useEffect(() => {
    setIsNeedFullScreenNeed(true);
    return () => {
      setIsNeedFullScreenNeed(false);
    };
  }, [setIsNeedFullScreenNeed]);
  //
  // LifeCycles

  // const createMarkup = (markup: string) => {
  //   return {
  //     __html: markup,
  //   };
  // };

  return (
    <div
      className={`${styles.quizCreatorAnswerShower} w-full flex flex-col items-center dark:!text-black`}
    >
      <div
        className={`${styles.topItem} w-full flex flex-row-reverse items-center justify-between relative`}
      >
        <div
          className={`${styles.right} w-1/2 flex flex-row-reverse items-start justify-start `}
        >
          <img src={quiz_result_header} alt="" />
          <p className="pt-4  text-base">پاســــخنــامه</p>
          <BiArrowBack
            className="absolute top-3 left-3  text-2xl"
            onClick={() => {
              navigate(-1);
            }}
          />
        </div>
        <div className={`${styles.left} h-full flex items-end `}>
          {currMode === "full" || undefined ? (
            <></>
          ) : (
            <span
              style={{ background: `rgb(255, 83, 52)` }}
              className="py-1 px-3 mx-1 my-1 rounded-md text-white text-sm cursor-pointer"
              onClick={() => {
                navigate("/profile/pdf-maker", {
                  state: {
                    lessonData: `${
                      lessonData ? lessonData.lessonName : " "
                    } ${""}`,
                  },
                });
              }}
            >
              PDF ساخت
            </span>
          )}
        </div>
      </div>
      {mixedQuestionAndUserAnswer.map((item, index) => (
        <div
          key={item.questions.id}
          className=" flex flex-col items-start my-4 p-4 rounded-xl mx-4 "
        >
          <p className="flex items-center pb-4">
            <span className="w-5 h-5 flex items-center justify-center text-white text-xs rounded-full bg-purple-400 ">
              {index + 1}
            </span>
            <span className="text-xs ml-2">
              {currMode === "full" || undefined ? (
                <></>
              ) : (
                <>{lessonData ? lessonData.lessonName : ""}</>
              )}
            </span>
          </p>
          {/*  */}
          {/*  */}
          {/*  */}
          {/*  */}
          {/*  */}
          {/*  */}
          {/*  */}
          <div className="w-full" style={{ borderBottom: `1px solid #858585` }}>
            {!!item.questions.title ? (
              <div
                className={`${styles.questionTitle} w-full text-right mt-3 block pb-2`}
                style={{
                  direction: "rtl",
                }}
              >
                {parse(item.questions.title)}
              </div>
            ) : null}
            {!!item.questions.image_url ? (
              <a
                href={item.questions.image_url.replace(
                  /(http[^\s])/i,
                  "https:"
                ).replace("::", ":")}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={item.questions.image_url.replace(
                    /(http[^\s])/i,
                    "https:"
                  ).replace("::", ":")}
                  className="mt-3 object-contain"
                  alt="questionImage "
                />
              </a>
            ) : null}
          </div>
          {/*  */}
          {/*  */}
          {/*  */}
          {/*  */}
          {/*  */}
          {/*  */}
          {/*  */}
          <div
            className={`${styles.optionsContainer} flex flex-col items-end w-full`}
          >
            {item.questions.options.map((_item: any, _index: number) => (
              <div
                key={_item.id}
                className={`${styles.option} ${
                  _item.is_correct ? "bg-green-300" : "bg-red-300"
                }`}
              >
                {_item.image_url ? (
                  <a
                    href={_item.image_url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center justify-between w-full"
                  >
                    <img
                      src={_item.image_url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
                      alt="question Img"
                      className="mt-3 "
                      style={{ width: "calc(80% - 3rem)" }}
                    />
                    <span
                      style={{
                        width: "3rem",
                      }}
                      className="flex items-center justify-between"
                    >
                      {String(item.userAnswer) === String(_item.id) && (
                        <GrRadialSelected fill="black" className="text-base" />
                      )}
                      {String(_item.is_correct) === "1" && (
                        <MdOutlineDone fill="green" className="text-base" />
                      )}
                    </span>
                  </a>
                ) : null}

                {_item.title ? (
                  <p
                    className={`w-full text-right mt-3 flex flex-row items-center justify-between `}
                  >
                    <p
                      className={`${styles.title} `}
                      style={{
                        width: "90%",
                        direction: "rtl",
                      }}
                    >
                      {parse(_item.title)}
                    </p>

                    <p
                      className=" flex items-center justify-end"
                      style={{
                        width: "3rem",
                      }}
                    >
                      {String(item.userAnswer) === String(_item.id) && (
                        <GrRadialSelected fill="black" className="text-base" />
                      )}
                      {String(_item.is_correct) === "1" && (
                        <MdOutlineDone fill="green" className="text-base" />
                      )}
                    </p>
                  </p>
                ) : null}
              </div>
            ))}
            {item.questions.answer_file_url !== "null" ? (
              <div
                className={`${styles.answerHolder} w-full flex flex-col items-end mt-5`}
              >
                <span
                  className="w-full text-right"
                  style={{
                    direction: "rtl",
                  }}
                >
                  پاسخ :{" "}
                </span>
                {item.questions.answer_file_url !== "null" ? (
                  <a
                    href={item.questions.answer_file_url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={item.questions.answer_file_url.replace(
                        /(http[^\s])/i,
                        "https:"
                      ).replace("::", ":")}
                      alt=""
                    />
                  </a>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuizCreatorAnswerShower;
